import axios from "axios";
import * as actionTypes from "./ActionTypes";

const BASE_URL = process.env.REACT_APP_BASE_API_URL;

const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem("authToken")}`,
});

// List sub-admins
export const getSubAdmins = (page = 1, perPage = 10) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_SUB_ADMINS_INIT });
  try {
    const res = await axios.get(`${BASE_URL}/admin/sub-admins`, {
      headers: authHeader(),
      params: { page, per_page: perPage },
    });
    dispatch({ type: actionTypes.GET_SUB_ADMINS_SUCCESS, payload: res.data });
    return res;
  } catch (error) {
    dispatch({ type: actionTypes.GET_SUB_ADMINS_FAIL });
    throw error;
  }
};

// Create sub-admin
export const createSubAdmin = (data) => async (dispatch) => {
  dispatch({ type: actionTypes.CREATE_SUB_ADMIN_INIT });
  try {
    const res = await axios.post(`${BASE_URL}/admin/sub-admins`, data, {
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    dispatch({ type: actionTypes.CREATE_SUB_ADMIN_SUCCESS, payload: res.data });
    return res;
  } catch (error) {
    dispatch({ type: actionTypes.CREATE_SUB_ADMIN_FAIL });
    throw error;
  }
};

// Update sub-admin
export const updateSubAdmin = (id, data) => async (dispatch) => {
  dispatch({ type: actionTypes.UPDATE_SUB_ADMIN_INIT });
  try {
    const res = await axios.put(`${BASE_URL}/admin/sub-admins/${id}`, data, {
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    dispatch({ type: actionTypes.UPDATE_SUB_ADMIN_SUCCESS, payload: res.data });
    return res;
  } catch (error) {
    dispatch({ type: actionTypes.UPDATE_SUB_ADMIN_FAIL });
    throw error;
  }
};

// Delete sub-admin
export const deleteSubAdmin = (id) => async (dispatch) => {
  dispatch({ type: actionTypes.DELETE_SUB_ADMIN_INIT });
  try {
    const res = await axios.delete(`${BASE_URL}/admin/sub-admins/${id}`, {
      headers: authHeader(),
    });
    dispatch({ type: actionTypes.DELETE_SUB_ADMIN_SUCCESS, payload: id });
    return res;
  } catch (error) {
    dispatch({ type: actionTypes.DELETE_SUB_ADMIN_FAIL });
    throw error;
  }
};
